/* 
  This component is intended to be at the top as a catch-all for
  unexpected errors.
*/

import { Component } from 'react'
import PropTypes from 'prop-types'
import { logException } from '../../logger'

export default class GlobalErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    logException(error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tw-flex tw-h-screen">
          <div className="tw-m-auto tw-max-w-lg tw-text-center tw-bg-white tw-p-16 tw-rounded">
            <h1 className="tw-uppercase">We are sorry!</h1>
            <p>
              An unexpected error has occured and the project can not be
              displayed. Please try again later, or contact support.
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

GlobalErrorBoundary.propTypes = {
  children: PropTypes.node,
}
